import { SET_IS_OPEN } from "../Actions/ShopTheLook.action";

const DEFAULT_STATE = {
    open: false,
    products: []
};

export const shopTheLook = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_IS_OPEN:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}